export const baseUrl = 'https://backend1.beta.aagebot.com';
export const membershipUrl = 'https://qxptjjcf4m.us-east-2.awsapprunner.com/v1.0/pay';
